import React, {useEffect, useState} from "react";
import {PaginaLogada} from "../../componentes";
import {Forca} from "../../tipos/forca";
import {ActionIcon, Badge, Center, ColorInput, Grid, Modal, Table, TextInput, Tooltip} from "@mantine/core";
import CardPadrao from "../../componentes/card/card-padrao";
import {useDisclosure} from "@mantine/hooks";
import {BotaoAdicionar, BotaoFechar, BotaoSalvar} from "../../componentes/botao/botao-mantine";
import {useForm} from "@mantine/form";
import {COL_RESP_6, COR, ICONE} from "../../config/constantes/constantes-mantine";
import {exibirMensagemSucesso} from "../../util";
import ForcaServico from "../../servicos/forca-servico";

export default function Forcas() {

  const [modal, {open, close}] = useDisclosure(false);
  const [isCarregando, setIsCarregando] = useState(false)
  const [flagAlterar, setFlagAlterar] = useState(false)
  const [lista, setLista] = useState<Forca[]>([])
  const form = useForm({
    initialValues: {
      nome: "",
      sigla:"",
      cor:"",
      emailAsplan:"",
    },
    validate: {
      nome: (value) => (value.length <= 4 ? "Nome muito curto" : null),
      sigla: (value) => (value.length < 2 ? "sigla muito curta" : null),
      cor: (value) => (value.length < 7 ? "Cor inválida" : null),
      // emailAsplan: (value) => (/^\S+@\S+$/.test(value) ? null : 'Email inválido')
    },
  });

  const buscarForcas = async () => {
    setIsCarregando(true)
    const result = await ForcaServico.buscarForcas();
    setLista(result)
    setIsCarregando(false)
  }

  useEffect(() => {
    buscarForcas();
  }, [])

  function salvarForca() {
    setIsCarregando(true)
    if (flagAlterar) {
      ForcaServico.alterarForca(form.values)
        .then(r => r.json())
        .then(json => {
          buscarForcas()
          exibirMensagemSucesso("Força alterada com sucesso")
        })
    } else {
      ForcaServico.salvarForca(form.values)
        .then(r => r.json())
        .then(json => {
          lista.push(json)
          setLista(lista)
          exibirMensagemSucesso("Força salva com Sucesso")
        })
    }
      setIsCarregando(false)
      form.reset()
      close()
  }

  function alterarForca(f: Forca) {
    setFlagAlterar(true)
    form.setValues(f)
    open()
  }

  return (
    <PaginaLogada titulo="Força" isCarregando={isCarregando}>

      <BotaoAdicionar onClick={open} />

      <CardPadrao titulo={"Lista de Forças"} mt={20}>
        <Table withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Nome</Table.Th>
              <Table.Th>Sigla</Table.Th>
              <Table.Th>Cor</Table.Th>
              <Table.Th>Email Asplan</Table.Th>
              <Table.Th>Ação</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {lista.map((f, k) => {
              return (
                <Table.Tr key={k}>
                  <Table.Td>{f.nome}</Table.Td>
                  <Table.Td>{f.sigla}</Table.Td>
                  <Table.Td>
                    <Badge color={f.cor}>
                      {f.cor}
                    </Badge>
                  </Table.Td>
                  <Table.Td>{f.emailAsplan}</Table.Td>
                  <Table.Td>
                    <Tooltip label={"Editar"}>
                      <ActionIcon
                        aria-label="Editar"
                        color={COR.ALERTA}
                        onClick={() => alterarForca(f)}
                      >
                      <ICONE.EDITAR/>
                    </ActionIcon>
                    </Tooltip>
                  </Table.Td>
                </Table.Tr>
              )
            })}
          </Table.Tbody>
        </Table>
      </CardPadrao>

      <Modal opened={modal} onClose={() => {close(); setFlagAlterar(false)}} size={"lg"} title={"Cadastrar Força"}>
        <form onSubmit={form.onSubmit(salvarForca)}>
          <Grid>
            <Grid.Col span={COL_RESP_6}>
              <TextInput
                required
                label={"Nome"}
                placeholder={"Ex. Polícia Militar"}
                {...form.getInputProps('nome')}
                onChange={(e) => form.setFieldValue("nome", e.currentTarget.value.toUpperCase())}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <TextInput
                required
                label={"Sigla"}
                placeholder={"Ex. PM"}
                {...form.getInputProps('sigla')}
                onChange={(e) => form.setFieldValue("sigla", e.currentTarget.value.toUpperCase())}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <ColorInput
                required
                label={"Cor"}
                placeholder={"#FFFFFF"}
                value={form.getValues().cor === null ? "" : form.getValues().cor}
                onChange={(e) => form.setFieldValue("cor", e.toUpperCase())}
                swatches={['#2e2e2e', '#868e96', '#fa5252', '#e64980', '#be4bdb', '#7950f2', '#4c6ef5', '#228be6', '#15aabf', '#12b886', '#40c057', '#82c91e', '#fab005', '#fd7e14']}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <TextInput
               label={"Email"}
               placeholder={"Email"}
               {...form.getInputProps('emailAsplan')}
               onChange={(e) => form.setFieldValue("emailAsplan", e.currentTarget.value)}
              />
            </Grid.Col>
            <Grid.Col span={12} mt={20}>
              <Center>
                <BotaoSalvar type={"submit"} m={5}/>
                <BotaoFechar onClick={() => {close(); setFlagAlterar(false)}} m={5}/>
              </Center>
            </Grid.Col>
          </Grid>
        </form>
      </Modal>
    </PaginaLogada>
  );
}